import script from "./DocumentItemTopButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentItemTopButtons.vue?vue&type=script&setup=true&lang=js"

import "./DocumentItemTopButtons.vue?vue&type=style&index=0&id=3920fc44&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3920fc44"]])

export default __exports__